import { HttpClient, NonNullablePaths } from '@wix/sdk-types';
import {
  GetWishlistByIdOptions,
  WishlistData,
  getWishlistById as universalGetWishlistById,
} from './platform-v1-wishlist-wishlist.universal.js';

export const __metadata = { PACKAGE_NAME: '@wix/stores' };

export function getWishlistById(
  httpClient: HttpClient
): GetWishlistByIdSignature {
  return (_id: string, options?: GetWishlistByIdOptions) =>
    universalGetWishlistById(
      _id,
      options,
      // @ts-ignore
      { httpClient }
    );
}

interface GetWishlistByIdSignature {
  /**
   * Get wishlist by id
   * @param - Unique identifier representing requested list
   * @returns Object containing requested list data
   */
  (_id: string, options?: GetWishlistByIdOptions): Promise<
    NonNullablePaths<
      WishlistData,
      | `ownerId`
      | `items`
      | `items.${number}._id`
      | `items.${number}.type`
      | `items.${number}.origin`
      | `totalCount`,
      4
    >
  >;
}

export {
  AccountInfo,
  AddToWishlistRequest,
  AddToWishlistResponse,
  GetWishlistByIdOptions,
  GetWishlistByIdRequest,
  GetWishlistByIdResponse,
  GetWishlistRequest,
  GetWishlistResponse,
  GetWishlistsRequest,
  GetWishlistsResponse,
  IdentificationData,
  IdentificationDataIdOneOf,
  ItemsAddedToWishlist,
  ItemsRemovedFromWishlist,
  MessageEnvelope,
  RemoveFromWishlistRequest,
  RemoveFromWishlistResponse,
  WebhookIdentityType,
  WishlistData,
  WishlistItem,
  WishlistItemKind,
} from './platform-v1-wishlist-wishlist.universal.js';
